export default "__VITE_ASSET__54a0cdef__"